<template>
  <!-- 碎片盒子管理-添加配置 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="添加配置"
      width="400px"
      @close="closeDialog"
    >
      <el-form
        :model="dataForm"
        ref="dataForm"
        label-width="100px"
        size="small"
        :rules="replyRules"
      >
        <el-form-item label="需要的碎片">
          <div
            class="selected-debris-box"
            v-for="(item, index) in dataForm.debris"
            :key="index"
          >
            <img :src="item.image" alt="" />
            <span>{{ item.name }}</span>
            <span class="delete-btn" @click="deleteItem(index)">删除</span>
          </div>
          <AddDebris
            v-if="dataForm.debris.length < 6"
            @selectedDebrisData="getSelectedDebrisData"
          ></AddDebris>
        </el-form-item>
        <el-form-item prop="probability" label="掉落概率">
          <el-input placeholder="请输入掉落概率" v-model="dataForm.probability">
          </el-input>
        </el-form-item>
        <el-form-item prop="water_limit" label="单号消耗流水">
          <el-input
            placeholder="请输入单号消耗流水"
            v-model="dataForm.water_limit"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="minimum_water" label="保底次数">
          <el-input
            placeholder="请输入保底次数"
            v-model="dataForm.minimum_water"
          >
          </el-input>
        </el-form-item>
        <!-- <el-form-item prop="status" label="配置状态">
          <el-select
            style="width: 140px"
            v-model="dataForm.status"
            placeholder="请选择配置状态"
          >
            <el-option label="关闭" :value="0"></el-option>
            <el-option label="正常" :value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import { getCookie } from '../../utils/cookie'
import saveFile from '@/utils/saveFile'
import AddGoods from '../../components/goods/AddGoods.vue'
import AddDebris from '../../components/debrisActivity/AddDebris.vue'

export default {
  components: {
    AddGoods,
    AddDebris
  },
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      imgType: 'prize',//上传图片的种类 奖品
      dataForm: {
        probability: '',
        water_limit: '',
        minimum_water: '',
        status: 0,
        debris: []
      },
      replyRules: {//回复弹窗规则验证

      }
    }
  },
  computed: {
    ...mapState({
    }),
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}file`
    },
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.fromInfo) {
        this.dataForm = this.fromInfo
      } else if (val && !this.fromInfo) {
        this.dataForm = {
          probability: '',
          water_limit: '',
          minimum_water: '',
          status: 0,
          debris: []
        }
      }
    },
  },
  created() {
  },
  methods: {
    submit() {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      let params = this.dataForm
      if (this.type === 1) {
        postApiData('box_debris', params).then(res => {
          this.$message.success("添加成功")
          this.$emit('refresh')
          this.closeDialog()
        }).finally(() => {
          this.buttonLoading = false
        })
      } else if (this.type === 2) {
        patchApiData(`box_debris/${this.dataForm.id}`, params).then(res => {
          this.$message.success("编辑成功")
          this.$emit('refresh')
          this.closeDialog()
        }).finally(() => {
          this.buttonLoading = false
        })
      }
    },
    getSelectedData(data) {
      //选择物品数据
      this.dataForm.prize_id = data.id
    },
    getSelectedDebrisData(data) {
      // 选择碎片数据
      if (this.dataForm.debris.length >= 6) {
        this.$message.error("最多选择六个碎片")
        return
      }
      // let params={
      //   id:data.category.id,
      //   name:data.category.name,
      //   image:data.image,
      //   num:data.num        
      // }
      this.dataForm.debris.push(data)
    },
    deleteItem(index) {
      this.dataForm.debris.splice(index, 1)
    },
    beforeImageUpload(file) {
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error('图片尺寸过大，请选择2M大小以下的图片上传')
        return false
      }
    },
    handleUploadSuccess(res) {
      if (res.path) {
        this.dataForm.image = res.path
      } else {
        this.$message.error('上传失败')
      }
      this.$refs['dataForm'].validateField('image')
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
.selected-debris-box {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 20px;
  img {
    width: 50px;
    margin-right: 10px;
  }
  .delete-btn {
    cursor: pointer;
    flex-shrink: 0;
    margin-left: 10px;
    color: rgba(255, 0, 0, 0.8);
    &:hover {
      color: rgba(255, 0, 0, 1);
    }
  }
}
</style>